import script from "./task-record-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./task-record-list.vue?vue&type=script&lang=tsx&setup=true"

import "./task-record-list.vue?vue&type=style&index=0&id=1fc702a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc702a8"]])

export default __exports__